import { createContext } from 'react';

const ReviewContext = createContext();

export default ReviewContext;
